// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1jcV1","content":"styles_content__35RHw","checkbox":"styles_checkbox__2PZV3","checkboxLabel":"styles_checkboxLabel__NFgXL"};